/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type shifts_UpdateShiftSeriesRequest = {
    /**
     * Optional break end time in HH:MM 24-hour format (e.g., "13:00"). Local to the organization's timezone.
     */
    break_end?: string;
    /**
     * Break duration in minutes (subtracted from gross hours to calculate net hours)
     */
    break_minutes?: number;
    /**
     * Optional break start time in HH:MM 24-hour format (e.g., "12:00"). Local to the organization's timezone.
     */
    break_start?: string;
    /**
     * Timestamp of when the shift was last updated, used for optimistic locking (RFC3339 format)
     */
    current_updated_at: string;
    /**
     * End time in HH:MM 24-hour format (e.g., "16:00"). Local to the organization's timezone.
     */
    end_time: string;
    /**
     * Optional list of group IDs to assign to shifts
     */
    group_ids?: Array<string>;
    /**
     * Optional notes about the shift
     */
    notes?: string;
    /**
     * Recurrence type (only for entire_series scope): DAILY, WEEKDAYS, WEEKLY, CUSTOM_WEEKDAYS
     */
    recurrence_type?: shifts_UpdateShiftSeriesRequest.recurrence_type;
    /**
     * Number of repetitions (only for entire_series scope, 1-365 for DAILY/WEEKDAYS/CUSTOM_WEEKDAYS, 1-52 for WEEKLY)
     */
    repetitions?: number;
    /**
     * Type of shift: REGULAR (standard work), OVERTIME (extra hours), ON_CALL (availability)
     */
    shift_type: shifts_UpdateShiftSeriesRequest.shift_type;
    /**
     * Start time in HH:MM 24-hour format (e.g., "08:00"). Local to the organization's timezone.
     */
    start_time: string;
    /**
     * Optional status for the shifts of the scope (#2119): this_and_future and entire_series move every non-exception shift of the scope to it with the publication and confirmation stamps of a single edit (publishing pushes shift_published, cancelling a published shift pushes the series cancellation); this_only saves it on the shift. Omitted keeps the statuses.
     */
    status?: shifts_UpdateShiftSeriesRequest.status;
    /**
     * Scope of the update: this_only, this_and_future, or entire_series
     */
    update_scope: shifts_UpdateShiftSeriesRequest.update_scope;
    /**
     * Selected ISO weekdays (1=Mon .. 7=Sun) for CUSTOM_WEEKDAYS recurrence (only for entire_series scope). Required (>=1 value) when recurrence_type is CUSTOM_WEEKDAYS.
     */
    weekdays?: Array<number>;
};
export namespace shifts_UpdateShiftSeriesRequest {
    /**
     * Recurrence type (only for entire_series scope): DAILY, WEEKDAYS, WEEKLY, CUSTOM_WEEKDAYS
     */
    export enum recurrence_type {
        DAILY = 'DAILY',
        WEEKDAYS = 'WEEKDAYS',
        WEEKLY = 'WEEKLY',
        CUSTOM_WEEKDAYS = 'CUSTOM_WEEKDAYS',
    }
    /**
     * Type of shift: REGULAR (standard work), OVERTIME (extra hours), ON_CALL (availability)
     */
    export enum shift_type {
        REGULAR = 'REGULAR',
        OVERTIME = 'OVERTIME',
        ON_CALL = 'ON_CALL',
    }
    /**
     * Optional status for the shifts of the scope (#2119): this_and_future and entire_series move every non-exception shift of the scope to it with the publication and confirmation stamps of a single edit (publishing pushes shift_published, cancelling a published shift pushes the series cancellation); this_only saves it on the shift. Omitted keeps the statuses.
     */
    export enum status {
        DRAFT = 'DRAFT',
        PUBLISHED = 'PUBLISHED',
        CONFIRMED = 'CONFIRMED',
        CANCELLED = 'CANCELLED',
    }
    /**
     * Scope of the update: this_only, this_and_future, or entire_series
     */
    export enum update_scope {
        THIS_ONLY = 'this_only',
        THIS_AND_FUTURE = 'this_and_future',
        ENTIRE_SERIES = 'entire_series',
    }
}

